import styled from "styled-components";

const ClosedSubMenuWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 49px;
  background: var(--left-menu-header-color);
  border-bottom: 1px solid #212121;

  & + .menu-item-list {
    margin-top: 50px;
  }
`;

const CloseSubMenuBtn = styled.i`
  width: 47px;
  float: right;
  cursor: pointer;
  position: absolute;
  top: 17px;
  right: 0;
  &:hover .svg-wrapper .svg-icon {
    background-color: var(--second-color) !important;
  }

  .svg-wrapper .svg-icon {
    width: 16px;
    height: 16px;
    background-color: var(--white);
    top: auto;
  }
`;

const CloseSubMenuTitle = styled.p`
  text-transform: capitalize;
  font-family: var(--menu-close-sub-menu-title);
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  line-height: 17px;
  /* identical to box height */
`;

export { ClosedSubMenuWrapper, CloseSubMenuBtn, CloseSubMenuTitle };
